import config from "../config.js";
import RequestManager from "./request.js";
import axios from 'axios';

export default class TiersPayants {

    static async postRechercheFacturesWithJson(recherche, signal) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postRechercheFacturesWithJson`, {
                adeli: recherche.adeli,
                date_debut: recherche.date_debut,
                date_fin: recherche.date_fin,
                recherche: recherche.recherche,
                nonrapprochees: recherche.nonrapprochees,
                rapprochees: recherche.rapprochees,
                toutes: recherche.toutes
            },
            signal
            );
            return response || [];
        } catch (error) {
            if (error.name === 'CanceledError') {
                console.log("Requête annulée");
            } else {
                console.error("Erreur lors de la réceptions des factures :", error); 
            }
            throw error;   
        }
    }

    static async postEnvoyerRapportReclamation(data) {
        console.log("ENVOIE DE LA DATA : ", data.idFac);
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postEnvoyerRapportReclamation`, {
                email: data.mail,
                tel: data.tel,
                reclamationText: data.reclamationText,
                nofact: data.nofact,
                partAmo: data.partAmo,
                codeRegion: data.codeRegion,
                idFac: data.idFac,
                rpps: data.rpps,
                both: data.double
            });
            return response;
        } catch (error) {
            console.error("Erreur lors de l'enregistrement du rapport de réclamation : ", error);
            throw error;
        }
    }

    static async getInfosFacture(nofact) {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}TiersPayants/getInfosFacture?nofact=${nofact}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération de la facture : ", error);
            throw error;
        }
    }

    static async postForcerPartAMOouAMC(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postForcerPartAMOouAMC`, {
                partAmo: data.partAmo,
                nofact: data.nofact
            });
            return response;
        } catch (error) {
            if (data.partAmo == true) {
                console.error("Erreur lors du forcement de la part Amo : ", error);
                throw error;
            } else {
                console.error("Erreur lors du forcement de la part Amc : ", error);
                throw error;
            }  
        }
    }

    static async postSolderFacture(nofact) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postSolderFacture?nofact=${nofact}`);
            return response;
        } catch (error) {
            console.error("Erreur pour solder la facture : ", error);
            throw error;
        }
    }

    static async postInfosComplementairesFacture(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postInfosComplementairesFacture`, {
                nofact: data.nofact,
                noEmetteur: data.noEmetteur,
                idps: data.idps
            });
            console.log("Réponse erreurs + rapport + rsp + pontuelle : ", response);
            return response;
        } catch (error) {
            console.error("Erreur pour la récupération des informations complémentaires de la factures : ", error);
            throw error;
        }
    }

    static async postRapprochementManuel(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}TiersPayants/postRapprochementManuel`, {
                nofact: data.nofact,
                ID: data.ID,
                nofse: data.nofse
            });
            console.log("Réponse rapprochement manuel : ", response);
            return response;
        } catch (error) {
            console.error("Erreur lors du rapprochement manuel des factures : ", error);
            throw error;
        }
    }
}
